import { useGlobal } from '@/utils/useGlobal';
import BackToTop from '@elem/compCommon/BackToTop';
import EmailSubscribe, { PAGE_TYPE } from '@elem/compCommon/EmailSubscribe';
import SideMenu, { SideMenuProps } from '@elem/compCommon/SideMenu';
import { createPortal } from 'react-dom';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import F from './components/F';
import G from './components/G';
import H from './components/H';
import I from './components/I';
import J from './components/J';
import K from './components/K';
import L from './components/L';
import M from './components/M';
import N from './components/N';
import O from './components/O';
import P from './components/P';

export default function IndexDynamic() {
    const { useState, useLang, useRouter, useEffect } = useGlobal();
    const { t } = useLang('powerindependence');
    const { locale } = useRouter();
    const [isClient, setIsClient] = useState(false);

    const obj: SideMenuProps = {
        items: [
            { text: t('secC_list1_title'), link: '#power-independence-D' },
            { text: t('secC_list2_title'), link: '#power-independence-F' },
            { text: t('secC_list3_title'), link: '#power-independence-J' },
        ],
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    const NEW_SITE = ['de', 'eu', 'uk', 'it', 'es'];
    const SHOW_NEW_SITE = NEW_SITE.includes(locale);

    const HIDE_N_SITE = ['eu'];
    const HIDE_N = HIDE_N_SITE.includes(locale);

    // 隐藏 POWER_STREAM
    const HIDE_POWER_STREAM_SITE = ['uk'];
    const HIDE_PS = HIDE_POWER_STREAM_SITE.includes(locale);

    // 隐藏 POWER_OCEAN
    const HIDE_POWER_OCEAN_SITE = ['it', 'es'];
    const HIDE_PO = HIDE_POWER_OCEAN_SITE.includes(locale);

    const HIDE_I_SITE = ['it', 'es'];
    const HIDE_I = HIDE_I_SITE.includes(locale);

    return (
        <>
            {SHOW_NEW_SITE && <P />}
            <C />
            {!SHOW_NEW_SITE && (
                <>
                    <D />
                    <E />
                </>
            )}
            {!HIDE_PS && (
                <>
                    <F />
                    <G />
                </>
            )}
            <EmailSubscribe
                locale={locale}
                className="email-subscribe"
                pageType={PAGE_TYPE.PowerIndependence}
                entry_position={locale === 'uk' ? 4 : locale === 'fr' ? 7 : 6}
            />
            {SHOW_NEW_SITE && (
                <>
                    {!HIDE_PS && <H />}
                    {!HIDE_PO && (
                        <>
                            <D />
                            <E />
                            <B />
                        </>
                    )}
                </>
            )}
            <J />
            <K />
            {SHOW_NEW_SITE && !HIDE_I && <I />}
            <L />
            <M />
            {!HIDE_N && <N />}
            <O />
            {isClient && createPortal(<SideMenu items={obj.items} />, document.querySelector('#Widgets-box-in2-right-id') || document.body)}
        </>
    );
}
